import _ from '@lodash';
import { List, ListItem, ListItemText, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import classNames from 'classnames';
import React from 'react';
import { BsCreditCard } from 'react-icons/bs';
import { CgArrowsExchange } from 'react-icons/cg';
import { FaRegMoneyBillAlt, FaRegNewspaper } from 'react-icons/fa';
import { GiFire } from 'react-icons/gi';
import { ImBarcode } from 'react-icons/im';
import { MdAdd, MdDone, MdLabel, MdToday } from 'react-icons/md';
import { RiBankLine, RiTimerLine } from 'react-icons/ri';
import { TiMinus } from 'react-icons/ti';

const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: 8,
    },
    item: {
        height: 40,
        borderRadius: '0 20px 20px 0',
        paddingRight: 12,
        '&.active': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText + '!important',
            transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
            '& .list-item-text-primary': {
                color: 'inherit'
            },
            '& .list-item-icon': {
                color: 'inherit'
            }
        },
        '&.square, &.active.square': {
            width: '100%',
            borderRadius: '0'
        },
        '& .list-item-icon': "folder",
        '& .list-item-text': {},
        color: theme.palette.text.primary,
        textDecoration: 'none!important'
    }
});

class MenuFiltro extends XAPPComponent {

    state = {
        condicao: null
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.condicao, this.state.condicao)) {
            this.props.setCondicoes(this.props.campo, this.state.condicao);
        }

        if (!_.isEqual(prevProps.data, this.props.data)) {
            this.setState({ condicao: null });
        }
    }

    setConditions = (_AValue) => {
        var { condicao } = this.state;
        var ACondicoes = [];
        if (!_.isUndefined(condicao) && !_.isNull(condicao)) {
            ACondicoes = JSON.parse(JSON.stringify(condicao));
        }

        if (ACondicoes.length > 0) {
            if (!this.IsSelected(_AValue)) {
                ACondicoes.push(_AValue);
            }
            else {
                var AIndex = _.indexOf(ACondicoes, _AValue);
                ACondicoes.splice(AIndex, 1);
            }
        }
        else {
            ACondicoes.push(_AValue);
        }

        this.setState({ condicao: ACondicoes.length > 0 ? ACondicoes : null });
    }

    IsSelected = (_AValue) => {
        var ASelected = false;
        var { condicao } = this.state;
        if (!_.isUndefined(condicao) && !_.isNull(condicao)) {
            if (condicao.includes(_AValue.toString())) {
                ASelected = true;
            }
        }
        return ASelected;
    }

    getItens = () => {
        var AResponse = [];
        const { data, campo } = this.props;

        if (!_.isUndefined(data) && !_.isNull(data)) {
            data.forEach(item => {
                if (!_.isUndefined(item[campo]) && !_.isNull(item[campo]) && item[campo].length > 0 &&
                    _.isUndefined(_.find(AResponse, { id: item[campo] }))) {
                    AResponse.push({ id: item[campo], label: item[campo] });
                }
            });
        }
        return AResponse;
    }

    getIcone = (_AName) => {
        switch (_AName.toString().toLowerCase()) {
            case 'a pagar':
            case 'a receber': return <RiTimerLine className="list-item-icon text-18" color="action" />
            case 'vencido': return <GiFire className="list-item-icon text-18 text-red" />
            case 'baixado': return <MdDone className="list-item-icon text-18 text-green" />
            case 'hoje': return <MdToday className="list-item-icon text-18 text-blue" />
            case 'dinheiro': return <FaRegMoneyBillAlt className="list-item-icon text-18" color="action" />
            case 'cartão de crédito':
            case 'cartão de débito': return <BsCreditCard className="list-item-icon text-18" color="action" />
            case 'cheque': return <FaRegNewspaper className="list-item-icon text-18" color="action" />
            case 'transferência bancária': return <CgArrowsExchange className="list-item-icon text-18" color="action" />
            case 'boleto': return <ImBarcode className="list-item-icon text-18" color="action" />
            case 'depósito': return <RiBankLine className="list-item-icon text-18" color="action" />
            default: return <MdLabel className="list-item-icon text-18" color="action" />
            case 'receber': return <MdAdd className="list-item-icon text-18 text-green" />
            case 'pagar': return <TiMinus className="list-item-icon text-18 text-red" />
        }
    }

    render() {
        const { classes, data, nome } = this.props;
        const AItens = this.getItens();

        return (
            <div className="flex-auto border-l-1 border-solid">
                {AItens.length > 0 &&
                    <List>
                        <Typography className="pr-24 pl-12" disableSticky>{"- " + nome}</Typography>
                        {AItens.map((item) => (
                            <ListItem
                                button
                                key={item.id}
                                className={classNames(classes.item, 'list-item', 'list-item-icon', this.IsSelected(item.id) && 'active')}
                                onClick={() => {
                                    this.setConditions(item.id);
                                }}
                            >
                                {this.getIcone(item.id)}
                                <ListItemText style={{ textTransform: "capitalize" }} primary={item.label} disableTypography={true} />
                            </ListItem>
                        ))}
                    </List>
                }
            </div>
        );
    }
}


export default withStyles(styles, { withTheme: true })(MenuFiltro);
